export default "__VITE_ASSET__ygeXN9wV__"